import "./IcebreakerPreviewResponses.scss";

import { Avatar, Divider, Flex, Text } from "@fluentui/react-northstar";
import { TeamsSurveyEmojiResponse, TeamsSurveyResponse } from "@teams/types";
import { SurveyDTO } from "@teams/types/api";

import { useUserInfo } from "../../../../../_shared/actions/useUserInfo";
import { EmojiReactions } from "../../../../../_shared/components/EmojiReactions";

type IcebreakerPreviewResponsesProps = {
  survey: SurveyDTO;
  responses: TeamsSurveyResponse[];
  totalResponses: number;
};

const MAX_RESPONDENTS = 3;

export const IcebreakerPreviewResponses: React.FC<IcebreakerPreviewResponsesProps> = ({
  survey,
  responses,
  totalResponses,
}) => {
  const { user } = useUserInfo();

  responses = responses.sort((a, b) => {
    const aTime = a.completedOn?.getTime() || 0;
    const bTime = b.completedOn?.getTime() || 0;
    return bTime - aTime;
  });

  const userResponse = responses.find(response => response.user.aadObjectId === user.userId);

  return (
    <>
      {totalResponses === 0 && <Text content="Be the first to respond!" weight="semibold" />}
      {totalResponses > 0 && (
        <IcebreakerPreviewResponsesList survey={survey} responses={responses} />
      )}

      {userResponse && (
        <div>
          <span className="icebreaker-preview-responses__submission">You submitted:</span>{" "}
          <span className="icebreaker-preview-responses__user-response">
            {userResponse.responses[0]?.value}
          </span>
        </div>
      )}
    </>
  );
};

const IcebreakerPreviewResponsesList: React.FC<{
  survey: SurveyDTO;
  responses: TeamsSurveyResponse[];
}> = ({ survey, responses }) => {
  let truncatedResponses = responses;
  if (responses.length > MAX_RESPONDENTS) {
    truncatedResponses = responses.slice(0, MAX_RESPONDENTS);
  }

  return (
    <>
      <div className="icebreaker-preview-responses__response-item-list">
        {truncatedResponses.map(response => (
          <IcebreakerResponseItem key={response.id} survey={survey} response={response} />
        ))}
      </div>

      <Text size="smaller" align="center" content={`Showing latest ${truncatedResponses.length}`} />

      <Divider />

      <Text content={`Total submissions: ${responses.length}`} weight="semibold" />
    </>
  );
};

const IcebreakerResponseItem: React.FC<{
  survey: SurveyDTO;
  response: TeamsSurveyResponse;
}> = ({ survey, response }) => {
  const reactions = (response as TeamsSurveyEmojiResponse).reactions || [];

  return (
    <div className="icebreaker-preview-responses__response-item">
      <Flex gap="gap.smaller" vAlign="center">
        <Avatar name={response.user.name || "Anonymous"} size="smallest" />
        <Text content={response.user.name} size="small" />
      </Flex>
      <Text content={response.responses[0]?.value} size="smallest" />
      {reactions.length > 0 && (
        <EmojiReactions size="small" survey={survey} reactions={reactions} />
      )}
    </div>
  );
};
